const radConfig = {
  allottement_status: false,
  currentUrl: "https://vitalrad.aikenist.com/",
  previousVisitUrl: "https://medapps.medallcorp.in",
  baseUrl: "https://vitalrad.aikenist.com/api/quickrad",
  baseUrlRadio: "https://vitalrad.aikenist.com/api/quickrad/radio",
  radTitle: "AIkenist Technology Pvt. Ltd.",
  viewerURL: "https://vitalrad.aikenist.com/aikenviewer/viewer/",
  viewer3DURL:"https://vitalrad.aikenist.com/3daikenviewer/viewer?StudyInstanceUIDs=",
  viewerPET:"https://vitalrad.aikenist.com/3daikenviewer/tmtv?StudyInstanceUIDs=",
  viewerSM:"https://vitalrad.aikenist.com/3daikenviewer/microscopy?StudyInstanceUIDs=",  
  viewerSeg:"https://vitalrad.aikenist.com/3daikenviewer/segmentation?StudyInstanceUIDs=",  
  viewerMultiple: "https://vitalrad.aikenist.com/3daikenviewer/viewer?",
  viewerMultiplePet: "https://vitalrad.aikenist.com/3daikenviewer/tmtv?",
  medDream:"https://vitalrad.aikenist.com/?study=",
  thumbnailURL: "https://vitalrad.aikenist.com/dicom-web/instances/",
  gifURL:
  "https://vitalrad.aikenist.com/api/quickrad/general/convert-to-gif?series_ins=",
  dicomWeb: "https://vitalrad.aikenist.com/dicom-web",
  weasisDicomWeb: "https://vitalrad.aikenist.com/dicom-web",
  studyList: "https://vitalrad.aikenist.com/dicom-web/studies",
  localViewer: "https://vitalrad.aikenist.com/aikenviewer/local",
  client: "vitalrad",
  paymentComplete: true,
  version: "v2.0",
  radiAntPath: "C:\\xampp\\htdocs\\python\\input_scan\\tmp"
};

// ******************************************

localStorage.setItem("client", radConfig.client);

if (
  localStorage.getItem("showTAT") == "" ||
  localStorage.getItem("showTAT") == null
) {
  localStorage.setItem("showTAT", "false");
}
if (
  localStorage.getItem("studyTracker") == "" ||
  localStorage.getItem("studyTracker") == null
) {
  localStorage.setItem("studyTracker", "false");
}

export default radConfig;
